import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useContext } from "react";
import { UserContext } from "components/context/UserProvider";
import Highlight from "components/ui/atoms/Highlight";
import Layout from "components/ui/molecules/Layout";
import {
  TopRightMenu,
  TopRightMenuItem,
} from "components/ui/molecules/TopRightMenu";
import { useModal } from "@ebay/nice-modal-react";

const AutomatedTasksHeader = ({ onCreated }) => {
  const theme = useTheme();
  const { hasPermission } = useContext(UserContext);
  const asyncProcessesModal = useModal("AsyncProcessesDrawer");

  return (
    <Layout title variant="component">
      <Grid container spacing={2} alignItems="center" sx={{ width: "100%" }}>
        <Grid>
          <Highlight color={theme.palette_custom.lightGreen}>
            Automated tasks
          </Highlight>
        </Grid>
        {hasPermission("app.add_asyncprocess") && (
          <Grid ml="auto">
            <TopRightMenu style={{ marginLeft: "auto" }}>
              <TopRightMenuItem
                endIcon={<AddIcon sx={{ scale: "0.8" }} />}
                onClick={() => {
                  asyncProcessesModal
                    .show({
                      formType: "create",
                    })
                    .then(onCreated);
                }}
              >
                Create
              </TopRightMenuItem>
            </TopRightMenu>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};

export default AutomatedTasksHeader;
